export class CanvasObject {
  constructor(id, locked, x, y, rad) {
    this.id = id;
    this.locked = locked || false;
    this.x = x || 0;
    this.y = y || 0;
    this.rad = rad || 8;
  }

  render(ctx) {
    ctx.save();
    this.draw(ctx);
    ctx.restore();
  }

  testHit(x, y) {
    return !this.locked
        && x >= this.x - this.rad
        && x <= this.x + this.rad
        && y >= this.y - this.rad
        && y <= this.y + this.rad;
  }

  startDrag(ptrX, ptrY) {
    this._drag = {ptrX, ptrY, x: this.x, y: this.y};
    this.active = true;
  }

  drag(ptrX, ptrY) {
    if (this._drag) {
      this.x = this._drag.x + ptrX - this._drag.ptrX;
      this.y = this._drag.y + ptrY - this._drag.ptrY;
    }
  }

  endDrag() {
    this._drag = null;
  }

  pos() {
    return {x: this.x, y: this.y};
  }

  setPos(pos) {
    this.x = pos.x;
    this.y = pos.y;
  }

  getPos() {
    return {x: this.x, y: this.y}
  }

  move(x, y) {
    this.x += x;
    this.y += y;
  }

  findObject(id) {
    return id === this.id ? this : null;
  }

  size() {
    return {width: 0, height: 0};
  }

  setSize() {
  }

  setActive(val) {
    this.active = val;
  }
}

export class ObjectComposition {
  constructor(id, objects) {
    this.id = id;
    this.objects = objects;
  }

  render(ctx) {
    if (this.drawBefore) {
      ctx.save();
      this.drawBefore(ctx);
      ctx.restore();
    }
    this.objects.forEach((obj) => obj.render(ctx));
    if (this.drawAfter) {
      ctx.save();
      this.drawAfter(ctx);
      ctx.restore();
    }
  }

  testHit(x, y) {
    // Hit any child?
    const hit = this.objects.find((obj) => obj.testHit(x, y));
    if (hit) {
      return hit;
    }

    // Hit rect?
    let firstObj = this.objects[0];
    let box = {x1: firstObj.x, y1: firstObj.y, x2: firstObj.x, y2: firstObj.y};
    this.objects.forEach((obj) => {
      box.x1 = Math.min(box.x1, obj.x);
      box.x2 = Math.max(box.x2, obj.x);
      box.y1 = Math.min(box.y1, obj.y);
      box.y2 = Math.max(box.y2, obj.y);
    });

    return !this.locked
        && x >= box.x1
        && x <= box.x2
        && y >= box.y1
        && y <= box.y2;
  }

  startDrag(ptrX, ptrY) {
    this.objects.forEach((obj) => obj.startDrag(ptrX, ptrY));
    this._drag = true;
    this.active = true;
  }

  drag(ptrX, ptrY) {
    if (this._drag) {
      this.objects.forEach((obj) => obj.drag(ptrX, ptrY));
    }
  }

  endDrag() {
    this._drag = null;
  }

  pos() {
    let firstObj = this.objects[0];
    let tl = {x: firstObj.x, y: firstObj.y};
    this.objects.forEach((obj) => {
      tl.x = Math.min(tl.x, obj.x);
      tl.y = Math.min(tl.y, obj.y);
    });
    return tl;
  }

  setPos(pos) {
    const tl = this.pos();
    const delta = {x: pos.x - tl.x, y: pos.y - tl.y};
    this.objects.forEach((obj) => obj.move(delta.x, delta.y));
  }

  getPos() {
    let limits = {};
    this.objects.forEach((obj) => {
      limits.minX = (limits.minX !== undefined) ? ( (limits.minX > obj.x) ? obj.x : limits.minX ) : obj.x;
      limits.maxX = (limits.maxX !== undefined) ? ( (limits.maxX < obj.x) ? obj.x : limits.maxX ) : obj.x;
      limits.minY = (limits.minY !== undefined) ? ( (limits.minY > obj.y) ? obj.y : limits.minY ) : obj.y;
      limits.maxY = (limits.maxY !== undefined) ? ( (limits.maxY < obj.y) ? obj.y : limits.maxY ) : obj.y;
    });
    let x = (limits.maxX - limits.minX) / 2 + limits.minX;
    let y = (limits.maxY - limits.minY) / 2 + limits.minY;
    return {x: x, y: y}
  }

  move(x, y) {
    this.objects.forEach((obj) => {
      obj.move(x, y);
    });
  }

  findObject(id) {
    if (id === this.id) {
      return this;
    }
    return this.objects.find((obj) => obj.findObject(id));
  }

  setActive(val) {
    this.active = val;
    this.objects.forEach((obj) => obj.active = val);
  }
}



// WEBPACK FOOTER //
// ./client/components/canvas/CanvasObject.js